function split(array: number[], by: number): number[][] {
  const result = [];
  let items = [];
  for (let i = 0; i <= array.length; i++) {
    if (i % by === 0 && i !== 0) {
      result.push(items);
      items = [];
    }
    items.push(array[i]);
  }
  return result;
}

function findZCoordinateRange(points: number[][]): { min: number, max: number } {
  let min = Number.MAX_VALUE;
  let max = Number.MIN_VALUE;
  for (let i = 0; i < points.length; i++) {
    const zCoordinate = points[i][2];
    max = zCoordinate > max ? zCoordinate : max;
    min = zCoordinate < min ? zCoordinate : min;
  }
  return {min, max};
}

export const getStepHeight = (step) => {
  const positions = step.geometry.attributes.position.array;
  const vertices = split(positions, 3);
  const range = findZCoordinateRange(vertices);
  return Math.abs(range.min) + Math.abs(range.max);
};



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Stairs/getStepHeight.ts